<template>
  <div class="section-container">
    <div class="section-head" v-if="props.info.headPic">
      <div v-for="pic in props.info.headPic" :key="pic">
        <img :src="getImageUrl(pic)" loading="lazy" decoding="async" />
      </div>
    </div>

    <div class="section-content">
      <div v-for="(content, index) in props.info.contents" :key="content.id || index">
        <div v-if="content.imageGroupBreak" class="image-group-break"></div>
        <div v-if="content.pic" :class="imageContentClass('pic', index)">
          <img :src="getImageUrl(content.pic)" loading="lazy" decoding="async" />
        </div>
		
		<div v-if="content.nopaddingpic" :class="imageContentClass('nopaddingpic', index)">
		  <img :src="getImageUrl(content.nopaddingpic)" loading="lazy" decoding="async" />
		</div>
		
		<div v-if="content.video" class="video">
			<video width="100%" controls preload="metadata" :poster="getImageUrl(content.poster)">
			  <source :src="content.video" type="video/mp4" >
			  {{ getText('common.media.videoUnsupported') }}
			</video>
		</div>
		
		<!-- <div v-if="content.video" class="video">
			<video width="100%" controls :poster="getImageUrl(content.poster)">
			  <source :src="getVideoUrl(content.video)" type="video/mp4" >
			  您的浏览器不支持 video 标签。
			</video>
		</div> -->

		<div v-if="content.desc" class="section-desc" :style="alignmentStyle(content)">
		  <span > {{ content.desc }} </span>
		</div>
		
		<div v-if="content.strongText" class="section-desc" :style="alignmentStyle(content)">
		  <div v-html="content.strongText" class="new-strongText"></div>
		</div>

		<div v-if="content.heading" :class="['section-heading', `section-heading-level-${content.heading.level}`]" :style="alignmentStyle(content)">
		  <div v-if="content.heading.html" v-html="content.heading.html"></div>
		  <div v-else>{{ content.heading.text }}</div>
		</div>

		<div v-if="content.listHtml" class="section-list" :style="alignmentStyle(content)" v-html="content.listHtml"></div>

		<hr v-if="content.divider" class="section-divider" />

		<div v-if="content.richHtml" class="rich-html" v-html="content.richHtml"></div>

		<div v-if="content.quote && content.quote.length" class="section-quote" :style="{ borderLeftColor: props.categorycolor }">
		  <div v-for="(q, qi) in content.quote" :key="qi">
		    <div v-if="q.pic" class="pic">
		      <img :src="getImageUrl(q.pic)" loading="lazy" decoding="async" />
		    </div>

		    <div v-if="q.desc" class="section-desc" :style="alignmentStyle(q)">
		      <span>{{ q.desc }}</span>
		    </div>
		    <div v-if="q.strongText" class="section-desc" :style="alignmentStyle(q)">
		      <div v-html="q.strongText" class="new-strongText"></div>
		    </div>
		  </div>
		</div>

      </div>
    </div>

    <div class="section-footer" v-if="props.info.footerPic">
      <div v-for="pic in props.info.footerPic" :key="pic">
        <img :src="getImageUrl(pic)" loading="lazy" decoding="async" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { getImageUrl } from "@/utils/index";
import { getText } from "@/utils/language";

const props = defineProps({
  info: {
    Object,
    required: true,
  },
  categorycolor: {
    type: String,
    default: '#e75a29',
  },
});

function isImageContent(content) {
  return Boolean(content && (content.pic || content.nopaddingpic));
}

function imageContentClass(baseClass, index) {
  const contents = props.info.contents || [];
  return [
    baseClass,
    {
      'image-adjacent-prev': isImageContent(contents[index - 1]),
      'image-adjacent-next': isImageContent(contents[index + 1]),
    },
  ];
}

function alignmentStyle(content) {
  return content?.align ? { textAlign: content.align } : null;
}
</script>
<style>
.new-strongText {
  font-size: 21px;
  line-height: 33px;
  font-family: MiSans VF;
}

.new-strongText b,
.new-strongText strong {
  font-weight: 700;
}

.strong-text{
	font-weight: bold;
}

.mint-color-shortcode {
  font-weight: 800;
}
</style>
<style lang="scss" scoped>
.section-container {
  width: 100%;

  .section-head,
  .section-footer {
    padding-bottom: 50px;

    img {
      width: 100%;
      object-fit: cover;
    }
  }

  .section-footer {
    margin-top: 100px;
  }

  .section-content {
    width: 100%;

    .image-group-break {
      display: none;
    }

    .pic {
      width: 100%;
      margin: 50px 0px;

      &.image-adjacent-prev {
        margin-top: 0;
      }

      &.image-adjacent-next {
        margin-bottom: 0;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
	
	.nopaddingpic {
	  width: 100%;
	  margin: 0px 0px;
	
	  img {
	    width: 100%;
	    height: 100%;
	  }
	}
	
	.video{
		width: 100%;
		.video_fill{
			width: 100%;
			object-fit: fill;
		}
	}

    .section-desc {
      margin-top: 50px;
      white-space: pre-wrap;
      color: white;

      span {
        font-size: 21px;
        font-weight: 330;
        line-height: 33px;
        font-family: MiSans;
      }


    }

    .section-heading {
      margin-top: 64px;
      color: white;
      font-family: MiSans VF;
      font-weight: 700;
      line-height: 1.35;

      &.section-heading-level-2 {
        font-size: 28px;
      }

      &.section-heading-level-3 {
        font-size: 24px;
      }

      &.section-heading-level-4 {
        font-size: 21px;
      }
    }

    .section-list {
      margin-top: 32px;
      color: white;
      font-size: 21px;
      font-weight: 330;
      line-height: 33px;
      font-family: MiSans;

      :deep(ul),
      :deep(ol) {
        margin: 0;
        padding-left: 1.5em;
      }

      :deep(ul) {
        list-style: disc;
      }

      :deep(ol) {
        list-style: decimal;
      }

      :deep(li) {
        margin-top: 10px;
      }

      :deep(li:first-child) {
        margin-top: 0;
      }

      :deep(ul ul),
      :deep(ol ol),
      :deep(ul ol),
      :deep(ol ul) {
        margin-top: 10px;
      }
    }

    .section-divider {
      width: 100%;
      margin: 50px 0 0;
      border: 0;
      border-top: 1px solid rgba(255, 255, 255, 0.36);
    }

    .rich-html {
      margin-top: 50px;
      width: 100%;
    }

    .section-quote {
      margin-top: 50px;
      padding: 4px 0 4px 24px;
      border-left: 3px solid #e75a29;

      // 引用块内部第一个 desc/strongText 不再额外 margin-top，避免和 padding 叠加
      > div:first-child .section-desc,
      > div:first-child .pic {
        margin-top: 0;
      }

      // 引用块内块间距收紧
      .section-desc {
        margin-top: 20px;
      }

      .pic {
        margin: 20px 0;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

@media screen and (max-width: 922px) {
  .section-container {
    width: 100%;

    .section-head {
      font-size: 20px;
      font-weight: 520;
      line-height: 26.52px;
      text-align: left;
      padding-bottom: 0px;
      padding-top: 40px;
    }


    .section-content {
      margin: 20px 0;

      span {
        font-size: 12px;
        font-weight: 450;
        line-height: 23.87px;
        color: #f1f3f7;
      }

      .pic {
        height: 240px;
        border-radius: 12px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .newsinfo-time {
        margin-left: 24px;
      }

      .section-desc {
        margin-top: 20px;
        white-space: pre-wrap;

        span {
          color: white;
          font-size: 14px;
          line-height: 23px;
        }
      }

      .section-heading {
        margin-top: 32px;

        &.section-heading-level-2 {
          font-size: 20px;
        }

        &.section-heading-level-3,
        &.section-heading-level-4 {
          font-size: 18px;
        }
      }

      .section-list {
        margin-top: 20px;
        font-size: 14px;
        line-height: 23px;

        :deep(ul),
        :deep(ol) {
          padding-left: 1.35em;
        }

        :deep(li) {
          margin-top: 6px;
        }
      }

      .section-divider {
        margin-top: 30px;
      }

      .rich-html {
        margin-top: 20px;
        width: 100%;
      }

      .section-quote {
        margin-top: 20px;
        padding: 4px 0 4px 12px;
        border-left: 2px solid #e75a29;

        .section-desc {
          margin-top: 10px;
        }

        > div:first-child .section-desc,
        > div:first-child .pic {
          margin-top: 0;
        }

        .pic {
          margin: 10px 0;
        }
      }

    }





  }

}
</style>
